#wrapper {
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: column;
  margin-top: var(--spacer);
}

.title {
  margin-top: calc(var(--spacer) * 1.5);
  text-transform: uppercase;
  color: var(--chart-300-icon-buttons);
}

.module-info-text {
  display: block;
  margin: calc(var(--spacer) * 2) 0 0 0;
  padding: 0;
  color: var(--main-titles-inputs-600);
  font-size: var(--body-size-large);
  max-width: 650px;
  line-height: 21px;
  span {
    font-family: var(--font-family-secondary);
  }
}
